import { useOutletContext } from "react-router";

export type DashBoardContextType = {
  openAddCertificates: () => void;
};

export const useDashBoardContext = () =>
  useOutletContext<DashBoardContextType>();
